// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k27l","actions":"styles_actions__3zqzS","error":"styles_error__nKyyt","message":"styles_message__2VUfj"};